import { gql } from "@apollo/client";

export const FETCH_DIVISIONS_INVENTORY = gql`
  query GetDivisionsInventory {
    inventoryDashboard {
      inventories {
        monthsOnHand
        revenueEquivalent
        key: uuid
      }
      isDefault
      name
      key: uuid
    }
  }
`;

export const FETCH_DIVISIONS_INVENTORY_BY_ID = gql`
  query GetDivisionsInventoryById($uuid: ID!) {
    findInventoryByDivision(uuid: $uuid) {
      __typename
      inventories {
        monthsOnHand
        revenueEquivalent
        key: uuid
      }
      isDefault
      name
      children: productGroupFinancials {
        __typename
        inventories {
          monthsOnHand
          revenueEquivalent
          key: uuid
        }
        isDefault
        name
        children: productFinancials {
          __typename
          inventories {
            monthsOnHand
            revenueEquivalent
            key: uuid
          }
          isDefault
          name
          key: uuid
        }
        key: uuid
      }
      key: uuid
    }
  }
`;

export const UPDATE_DIVISIONS_INVENTORY = gql`
  mutation updateInventory($data: UpdateDivisionInventoryInput!) {
    updateInventoryByDivision(data: $data) {
      monthsOnHand
      revenueEquivalent
      uuid
    }
  }
`;

export const UPDATE_PRODUCT_GROUPS_INVENTORY = gql`
  mutation updateInventory($data: UpdateProductGroupInventoryInput!) {
    updateInventoryByProductGroup(data: $data) {
      monthsOnHand
      revenueEquivalent
      uuid
    }
  }
`;

export const UPDATE_PRODUCTS_INVENTORY = gql`
  mutation updateInventory($data: UpdateProductInventoryInput!) {
    updateInventoryByProduct(data: $data) {
      monthsOnHand
      revenueEquivalent
      uuid
    }
  }
`;

export const CREATE_DIVISION_INVENTORY = gql`
  mutation createInventory($data: CreateInventoryInput!) {
    createInventoryByDivision(data: $data) {
      division {
        isDefault
        name
        uuid
      }
      monthsOnHand
      revenueEquivalent
      uuid
    }
  }
`;
